<div style="margin-top: 15px;" class="base-container">
  <div nz-row nzType="flex" [nzJustify]="'center'">
    <div nz-col nzSpan="5" style="bottom: -11px;margin-left: 0px">
      <app-stepper-base-button
        [actionText]="'Comparison'"
        [contentBlock]="true"
        [actionIcon]="faChartBar"
        [height]="'100px'"
        [width]="'175px'"
        (onClick)="onClick('Comparison')"
        nz-popover
        nzOverlayClassName="btn-popover"
        [nzPopoverContent]="barContentTemplate"
        nzPopoverPlacement="bottomLeft"
        nzTrigger="click"
      >
      </app-stepper-base-button>
      <ng-template #barContentTemplate>
        <div style="margin-top:5px;">
          <p class="img-caption">Sample Bar Chart | Comparison</p>
          <img [src]="assets + '/bar-chart.png'" width="511px" height="200px" />
        </div>
      </ng-template>
    </div>
    <div nz-col nzSpan="5" style="bottom: -11px;margin-left: 15px">
      <app-stepper-base-button
        [actionText]="'Time Series'"
        [contentBlock]="true"
        [actionIcon]="faChartLineUp"
        [height]="'100px'"
        [width]="'175px'"
        (onClick)="onClick('Timeseries')"
        nz-popover
        [nzPopoverContent]="lineContentTemplate"
        nzPopoverPlacement="bottomLeft"
      >
      </app-stepper-base-button>
      <ng-template #lineContentTemplate>
        <div style="margin-top:5px;">
          <p class="img-caption">Sample Line Chart | Time Series</p>
          <img
            [src]="assets + '/line-chart.png'"
            width="511px"
            height="200px"
          />
        </div>
      </ng-template>
    </div>
    <div nz-col nzSpan="2" class="or-style">
      <div class="line"></div>
      <div class="text">OR</div>
      <div class="line"></div>
    </div>
    <div nz-col nzSpan="5" style="bottom: -11px;">
      <app-stepper-base-button
        [actionText]="'Revision'"
        [contentBlock]="true"
        [actionIcon]="faChartLineUp"
        [height]="'100px'"
        [width]="'175px'"
        (onClick)="onClick('line')"
        nz-popover
        [nzPopoverContent]="revContentTemplate"
        nzPopoverPlacement="bottomRight"
      >
      </app-stepper-base-button>
      <ng-template #revContentTemplate>
        <div style="margin-top:5px;">
          <p class="img-caption">Sample Revision Chart</p>
          <img [src]="assets + '/revision.png'" width="511px" height="200px" />
        </div>
      </ng-template>
    </div>
  </div>
</div>
